import { render } from "./University.vue?vue&type=template&id=05ebb8e6"
import script from "./University.vue?vue&type=script&lang=js"
export * from "./University.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__